export const GET_PRE_ORDERS_REQUESTED = 'GET_PRE_ORDERS_REQUESTED'
export const GET_PRE_ORDERS_SUCCEEDED = 'GET_PRE_ORDERS_SUCCEEDED'
export const GET_PRE_ORDERS_FAILED = 'GET_PRE_ORDERS_FAILED'
